import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=f67ce818&scoped=true&"
import script from "./KanbanCard.vue?vue&type=script&lang=js&"
export * from "./KanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=f67ce818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67ce818",
  null
  
)

export default component.exports